import React, { useState, useEffect, useRef } from "react";
import {
  NavLink,
  useNavigate,
  useParams,
  useSearchParams
} from "react-router-dom";
import gsap from "gsap";
import classNames from "classnames";
import LeftNav from './narrativeDetail/module.leftNav';
import Frame from './narrativeDetail/module.frame';
import TabButtons from "./narrativeDetail/module.tabButtons";
import LayerSettings from "./narrativeDetail/module.layerSettings";
import NarrativeTools from "./narrativeDetail/module.narrativeTools";
import PageSettings from './narrativeDetail/module.pageSettings';
import TemplateSettings from "./narrativeDetail/module.templateSettings";
import PageNotes from './narrativeDetail/module.pageNotes';
import Library from './library'
import Cookies from "js-cookie";
import { animDropDown } from "../utils/form.tools";
import { handlePostSave } from "./narrativeUtils/handlePostSave";
import { handleLayerAddedMain } from "./narrativeUtils/onLayerAdded";
import { fetchJSONMain, apiCall } from "./narrativeUtils/fetch";
import { updateVersionHistory, onUndoRedo } from "./narrativeUtils/versionHistory";

import showSettingsMain from "./narrativeUtils/showSettings";
import Config from "../Config.json";
import Modal from './module.modal';
import Icons from './module.icons';
import Loader from "../static/svg/loader.svg";
import {ReactComponent as ChevronDown} from "../static/icons/chevron_down.svg";
// import { version } from "react/cjs/react.production.min";


function Canvas(props) {
  const navigate = useNavigate();
    let { id } = useParams();
    const layerClickCooldownRef = useRef(false);
    const [saveCooldown, setSaveCooldown] = useState(false);
    const tempTextObj = useRef();
    const editorOn = useRef(null);
    const formInput = useRef(null);
    const tempNarrativeHeading = useRef();
    const undoRedo = useRef(false);
    const versionNumber = useRef(-1);
    const activeDisplayRef = useRef(-1);
    const destPageIdRef = useRef(null);
    const pendingHeadingChange = useRef(null);
    const prevActiveSettingIdRef = useRef(null);

    // const versions = useRef();

    // UI 
    const [showFullCanvas, setShowFullCanvas] = useState(true);
    const [activeDisplay, setActiveDisplay] = useState(null);
    const [aspectRatio, setAspectRatio] = useState(1); 
    const [showLoader, setShowLoader] = useState(true);
    const [showError, setShowError] = useState(false);
    const [triggerSaveForm, setTriggerSaveForm] = useState(false);
    const [showDeleteSection, setShowDeleteSection] = useState(false);
    const [baseZoomRatio, setBaseZoomRatio] = useState(0.463);
    const [zoomRatio, setZoomRatio] = useState(0.463);
    const [zoomNumber, setZoomNumber] = useState(1);
    const [zoomDelta, setZoomDelta] = useState(null);
    const [lockAr, setLockAr] = useState(true);
    const [dropDown, setDropDown] = useState();
    const [showPages, setShowPages] = useState(true);
    const [showNarrativeHeadingForm, setShowNarrativeHeadingForm] = useState(false);
    const [showFormatLockWarning, setShowFormatLockWarning] = useState(false);
    const [multiSelectIds, setMultiSelectIds] = useState([]);
    const [multiSelectObjs, setMultiSelectObjs] = useState([]);
    const [multiSelectPageIds, setMultiSelectPageIds] = useState([]);
    const [formError, setFormError] = useState();
    const [showPageForm, setShowPageForm] = useState(false);
    const [editPageForm, setEditPageForm] = useState(false);
    const [reload, setReload] = useState(0);
    const [acceptValues, setAcceptValues] = useState('init');
    const [animationPresets, setAnimationPresets] = useState([]);
    const [newTab, setNewTab] = useState(null);
    const [publishOn, setPublishOn] = useState(false);
    const [showFrame, setShowFrame] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(0);
    const [showAssetLibrary, setShowAssetLibrary] = useState(false);
    const [isDrawing, setIsDrawing] = useState(false);
    const [showTemplates, setShowTemplates] = useState(false);
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [showMoveModal, setShowMoveModal] = useState(false);
    

    // Active States
    const [searchParams, setSearchParams] = useSearchParams();
    const [sectionId, setSectionId] = useState(null);
    const [activeSectionObj, setActiveSectionObj] = useState(null);
    const [unSavedChanges, setUnSavedChanges] = useState(false);
    const [partnerChanges, setPartnerChanges] = useState([]);
    const [activeSettingId, setActiveSettingId] = useState(null);
    const [activeNarrativeHeading, setActiveNarrativeHeading] = useState();
    const [activeStateId, setActiveStateId] = useState(null);
  
    // Data
    const [narrative, setNarrative] = useState(null);
    const [sections, setSections] = useState(null);
    const [section, setSection] = useState(null);
    const [components, setComponents] = useState([]);
    const [componentDimensions, setComponentDimensions] = useState([]);
    const [stateImages, setStateImages] = useState(null);
    const [narrativeHeadings, setNarrativeHeadings] = useState();

    // Changes
    const [sectionChanges, setSectionChanges] = useState([]);
    const [newMedia, setNewMedia] = useState([]);
    const [newComponentID, setNewComponentID] = useState(null);
    const [newComponentPopUpID, setNewComponentPopUpID] = useState(null);
    const [newComponentDimension, setNewComponentDimension] = useState(null);
    const [unSavedLayerIds, setUnSavedLayerIds] = useState([]);
    const [newAnimObj, setNewAnimObj] = useState({});
    const [newStateAnimObj, setNewStateAnimObj] = useState({});
    const [narrativeChanges, setNarrativeChanges] = useState([]);
    const [selection, setSelection] = useState();
    // Debug: log selection changes
    useEffect(() => {
      console.log('PARENT: selection changed to:', selection);
    }, [selection]);
    const [windowSelection, setWindowSelection] = useState();
    const [forceVersion, setForceVersion] = useState(null);
    const [tempText, setTempText] = useState(null);
    const [rerender, setRerender] = useState(0);
    const [reloadFrame, setReloadFrame] = useState(0);
    const [missingMediaIds, setMissingMediaIds] = useState([]);

    // Versioning
    const [versionCount, setVersionCount] = useState(0);
    const [versionHistory, setVersionHistory] = useState(null);
    // const [versionNumber, setVersionNumber] = useState(-1);


    function stageLayerIds(objId){
      let newIds = [ ...unSavedLayerIds ];
      if (newIds.findIndex(a => a === objId) < 0) {
        newIds.push(objId)
        let obj = componentDimensions.find(a => a.id === objId);
        if (obj && obj.subs && obj.subs.length > 0) {
          obj.subs.forEach(sub => {
            newIds.push(sub.id)
          });
        }
        setUnSavedLayerIds(newIds);
        // console.log('stageLayerIds', newIds)
      }
      
    }

    function resizeTextLayersToFit(dimensions) {
      const changedIds = [];
      const updatedDims = dimensions.map(dim => {
        if (dim.file_format !== 'text' || !dim.html_text || !dim.html_text.text) {
          return dim;
        }

        const textEl = document.getElementById('dim_text_' + dim.id);
        if (!textEl) {
          return dim;
        }

        const range = document.createRange();
        range.selectNodeContents(textEl);
        const textRect = range.getBoundingClientRect();
        const containerRect = textEl.parentElement.getBoundingClientRect();

        if (containerRect.width === 0 || containerRect.height === 0) {
          return dim;
        }

        // Container screen size maps to known API pixel size
        const ratioW = dim.width / containerRect.width;
        const ratioH = dim.height / containerRect.height;
        const newWidth = Math.ceil(textRect.width * ratioW) + 2;
        const newHeight = Math.ceil(textRect.height * ratioH) + 2;

        // Width: only shrink to fit. Height: shrink or grow to fit.
        const finalWidth = Math.min(newWidth, dim.width);
        const finalHeight = newHeight;

        if (finalWidth === dim.width && finalHeight === dim.height) {
          return dim;
        }

        changedIds.push(dim.id);
        return { ...dim, width: finalWidth, height: finalHeight };
      });

      return { updatedDims, changedIds };
    }

    async function handleLayerSave(menuObj) {
      setPublishOn(true);
      setShowLoader(true);
      setFormError(null);
      setTempText(null);
      // Also clear the immediate text ref
      if (tempTextObj.current) {
        tempTextObj.current = null;
      }

      // Resize text layers to fit content before saving
      const { updatedDims, changedIds } = resizeTextLayersToFit(componentDimensions);

      // Stage any text layers that were resized so they get saved
      let updatedUnSavedLayerIds = unSavedLayerIds;
      if (changedIds.length > 0) {
        updatedUnSavedLayerIds = [...unSavedLayerIds];
        changedIds.forEach(id => {
          if (!updatedUnSavedLayerIds.includes(id)) {
            updatedUnSavedLayerIds.push(id);
          }
        });
        setComponentDimensions(updatedDims);
        setUnSavedLayerIds(updatedUnSavedLayerIds);
      }

      // Ensure the active layer is always in the save batch. stageLayerIds runs in a
      // multiSelectIds effect that fires after this effect (triggerSaveForm), so its
      // setUnSavedLayerIds hasn't flushed yet on consecutive saves after a clear.
      if (activeSettingId && !updatedUnSavedLayerIds.includes(activeSettingId)) {
        updatedUnSavedLayerIds = [...updatedUnSavedLayerIds, activeSettingId];
      }

      // Save pending heading change if any (direct API call, no fetchJSON to avoid zoom reset)
      if (pendingHeadingChange.current) {
        const headingUrl = Config.baseURLcms + 'narrativeheading-edit/';
        let headingData = { id: pendingHeadingChange.current.objId, heading: pendingHeadingChange.current.value };
        let newObjs = [...narrativeHeadings];
        let objIndex = newObjs.findIndex(x => x.id === pendingHeadingChange.current.objId);
        if (objIndex > -1) {
          newObjs[objIndex].heading = pendingHeadingChange.current.value;
          setNarrativeHeadings(newObjs);
        }
        apiCall("POST", headingUrl, headingData, null, null, setFormError, setShowLoader);
        pendingHeadingChange.current = null;
      }

      await handlePostSave(activeSettingId, setShowLoader, setUnSavedChanges, setNewAnimObj, sectionChanges, sectionId, handleSectionSave, updatedDims, handleComponentDimensionUpdate, multiSelectIds, handleEditAnimation, newAnimObj, handleAddAnimation, newStateAnimObj, setNewStateAnimObj, updatedUnSavedLayerIds, menuObj, setSectionId, setActiveNarrativeHeading, handleCloseSettings, setForceVersion, activeDisplay);
      return true
    }

    function updateVersionHistorySub(obj, source){
      updateVersionHistory(
        obj, 
        source, 
        undoRedo,
        versionCount, 
        setVersionCount, 
        versionNumber
        )
    }

    function handleDontSave(menuObj){
      // console.log('dont save')
      setUnSavedChanges(null)
      setUnSavedLayerIds([])
      if (menuObj){
        handleCloseSettings();
        if (menuObj.page) {
          setSectionId(menuObj.page);
          setActiveNarrativeHeading(menuObj);
        } else if (menuObj.page === null){
          setActiveNarrativeHeading(menuObj);
        } else {
          setSectionId(menuObj.id);
        }
    
        // console.log('menuObj', menuObj)
      }
      setTimeout(() => {
        fetchJSON()
      }, 200);
      
    }

    function fetchPresets(narrativeId) {
      const get_url = Config.baseURLcms + "animation-preset/" + narrativeId;

      function responseTask(response) {
        const assetJSON = response.data;
        setAnimationPresets(assetJSON);
      }
      apiCall("get", get_url, {}, responseTask, null, setFormError, setShowLoader)
    }

    useEffect(() => {

      console.log('NARRATIVE DETAIL LOADED')
      setVersionCount(0);
      setVersionHistory(null);
      props.setTools("canvas")
      fetchJSON(false);
      fetchPresets(id);
      editorOn.current = false;

      let versionHistory = JSON.parse(localStorage.getItem('versionHistory'));

      if (versionHistory && versionHistory.length > 0) {
        let versionNo = versionHistory[versionHistory.length - 1].version
        setVersionCount(versionHistory.length)
        versionNumber.current = versionNo
        // console.log('init version count and number', versionHistory.length, versionNo)
      }

      props.setSmLogo(true)
      return () => {
        props.setSmLogo(false);

      }

    }, []);

    useEffect(() => {
      if (showTemplates) {
        setActiveSettingId(null)
        setShowPages(true)
      }
    }, [showTemplates])

    // useEffect(() => {
    //   if (windowSelection) {
    //     function surroundSelection(element, sel) {
    //       if (sel.rangeCount) {
    //           var range = sel.getRangeAt(0).cloneRange();
    //           range.surroundContents(element);
    //           sel.removeAllRanges();
    //           sel.addRange(range);
    //       }
    //     }
    //     var span = document.createElement("span");
    //     let range = windowSelection.getRangeAt(0);


    //     // surroundSelection(span, windowSelection)

    //   }
    // }, [windowSelection])

    useEffect(() => {
      showNarrativeHeadingForm && document.getElementById('narrativeHeadingNew').focus();
    }, [showNarrativeHeadingForm])


    useEffect(() => {
      if (activeDisplay && activeDisplayRef.current !== activeDisplay.id) {
        activeDisplayRef.current = activeDisplay.id
      }
      // console.log('activeDisplay set', activeDisplay, activeDisplayRef.current)
      function loadDimension(callback) {
        if (components.length > 0) {

          const dims = [];
          for(var i = 0; i < components.length; i++) {
            var obj = components[i];
        
            var aspectDims = obj.dimensions.filter((dimension) => dimension.display === activeDisplay.id);
            if (aspectDims.length > 0) {
              dims.push(aspectDims[0]);
            }
            if (i === (components.length - 1)) {
              callback(dims);
            }
           
          }
      }
    }

    // CHANGE ASPECT RATIO
    function setDimensions(dims) {
      handleCloseSettings();
        if (partnerChanges.length > 0) {
          var newDims = [...dims];
          // console.log('partnerChanges', partnerChanges, newDims, dims);
          partnerChanges.forEach(function (partnerItem, partnerIndex) {
          if (partnerItem['id'] !== undefined) {
            // console.log('partnerItem', partnerItem, partnerItem['id'], partnerIndex, newDims);

            var dimPartnerIndex = newDims.findIndex(item => item.id === partnerItem['id']);
            if (dimPartnerIndex > -1) {
              if (partnerItem['component_ordering']) {
                newDims[dimPartnerIndex]['component_ordering'] = partnerItem['component_ordering']
              }
              newDims[dimPartnerIndex]['typeName'] = partnerItem['typeName'];
            }
            // console.log('partnerIndex', partnerIndex, partnerChanges.length, partnerItem);
            if ((partnerIndex+1) === partnerChanges.length){
              
              setComponentDimensions(newDims);
            }
          }
          
  
          });
        } else {
          setComponentDimensions(dims);
        }
      }
      setShowLoader(true);
      setZoomNumber(1)
      console.log('setting zoomNumber 1');

      setTimeout(() => {
  
        loadDimension(setDimensions);
        let elemHeight;
        let elemHeightObj = document.getElementById('canvasForm')
  
        if (elemHeightObj) {
          elemHeight = elemHeightObj.offsetHeight - 2;
          let ratio = elemHeight / activeDisplay.height_px
          // let ratio = elemHeight/(elemHeight*(elemHeightObj.offsetWidth - 2)/activeDisplay.aspect_ratio)
          console.log('zoomRatio', ratio, aspectRatio, elemHeightObj)
  
          setZoomRatio(ratio)
  
          if (narrative.default_display !== activeDisplay.id) {
            fetchJSON(null, true)
  
            
          }
          setShowLoader(false)
        }
      }, 100);

  
     
      
    }, [activeDisplay]);


    useEffect(() => {

      console.log('component dimensions', componentDimensions)
      var currPartnerChanges = [];
      let stateFiles = []; 
      componentDimensions.forEach(function (dimension, index) {
        if (dimension.is_locked) {
          var partnerIds = dimension.partner_ids;
          partnerIds.forEach(function (partnerId, index0) {
            
            var partnerChangesIndex = currPartnerChanges.findIndex(item => item.id === partnerId);
           
            if (partnerChangesIndex > -1) {
              currPartnerChanges[partnerChangesIndex] = dimension;
              //  console.log('currPartnerChanges:', currPartnerChanges, dimension);
            } else {
              var partnerObj = {};
              var newPartnerObj = Object.assign(partnerObj, dimension);
              newPartnerObj['id'] = partnerId;
              // console.log('newPartnerObj', partnerId, newPartnerObj);
              currPartnerChanges.push(newPartnerObj);
            }
          });
        }
        if (index === (componentDimensions.length - 1)) {
          setPartnerChanges(currPartnerChanges);
          // console.log('componentDimensions: setPartnerChanges', currPartnerChanges);
        }

        dimension.componentdimensionstateimages.forEach(obj => {
          stateFiles.push(obj);
        })

        if (index === (componentDimensions.length - 1)) {
          setStateImages(stateFiles)
          // console.log('stateFiles', stateFiles)
        }

      });

      // Check for missing media files by verifying URLs exist on server
      const checkMediaExists = async () => {
        const missingIds = [];

        // Use Image/Video elements instead of fetch to bypass CORS restrictions
        const checkUrl = (url, isVideo = false) => {
          if (!url || url === '') return Promise.resolve(false);
          return new Promise((resolve) => {
            if (isVideo) {
              const video = document.createElement('video');
              video.onloadedmetadata = () => resolve(true);
              video.onerror = () => resolve(false);
              video.src = url;
            } else {
              const img = new Image();
              img.onload = () => resolve(true);
              img.onerror = () => resolve(false);
              img.src = url;
            }
          });
        };

        const checks = componentDimensions.map(async (dimension) => {
          let mediaUrl = null;
          let isVideo = false;

          // Only check the relevant path for each format
          if (dimension.file_format === 'img') {
            // For images, only check image_path (ignore video_path)
            if (dimension.image_path) {
              mediaUrl = dimension.image_path;
            }
          } else if (dimension.file_format === 'vid') {
            // For videos, only check video_path (ignore image_path)
            if (dimension.video_path) {
              mediaUrl = dimension.video_path;
              isVideo = true;
            }
          }

          if (mediaUrl) {
            const exists = await checkUrl(mediaUrl, isVideo);
            if (!exists) {
              missingIds.push(dimension.id);
            }
          }
        });

        await Promise.all(checks);

        setMissingMediaIds(missingIds);
        if (missingIds.length > 0) {
          console.log('Missing media for layers:', missingIds);
        }
      };

      checkMediaExists();

    }, [componentDimensions]);


    const generalKeyDown = ({ repeat, metaKey, ctrlKey, shiftKey, key }) => {
   
      if (repeat) return
      onUndoRedo(
        undoRedo, 
        sections, 
        setActiveSectionObj, 
        versionNumber, 
        metaKey, ctrlKey, shiftKey, key, 
        versionCount, 
        setUnSavedLayerIds, 
        activeSectionObj,
        setShowLoader,
        fetchJSON,
        setFormError,
        setUnSavedChanges
        )
    }
    
    useEffect(() => {
     
      if (versionCount) {
        // console.log('versionCount', versionCount, versionNumber.current)
      }
    }, [versionCount])

    useEffect(() => {
      console.log('zoomNumber', zoomNumber)
    }, [zoomNumber])
  
    useEffect(() => {
      let versionHistory = JSON.parse(localStorage.getItem('versionHistory'));
      let versionObj = {
        obj: versionHistory, 
        versionCount: versionCount, 
        versionNumber: versionNumber.current
      }
      // console.log('version ping', versionObj)

      document.addEventListener('keydown', generalKeyDown)
      return () => document.removeEventListener('keydown', generalKeyDown)

      
    }, [versionCount, activeSectionObj])

    
     useEffect(() => {
       if (newComponentID) {
        console.log('newComponentID', newComponentID)
        const api_url = Config.baseURLcms + 'section-componentdimension-duplicate/';
        var formJSON = {
          'component_id': newComponentID
        }
        function responseTask() {
          // fetchJSON(false);
          
        }
        apiCall("POST", api_url, formJSON, responseTask, null, setFormError, setShowLoader)

 
    
       }
    }, [newComponentID]);


    useEffect(() => {
      if (newComponentPopUpID) {
       const api_url = Config.baseURLcms + 'section-componentdimension-popup-duplicate/';
       var formJSON = {
         'component_id': newComponentPopUpID
       }
       function responseTask() {
        fetchJSON(false);
        setNewComponentPopUpID(null);
      }
       apiCall("POST", api_url, formJSON, responseTask, null, setFormError, setShowLoader)
      
   
      }
   }, [newComponentPopUpID]);


  useEffect(() => {
    
   if (newComponentDimension && componentDimensions) {;
      console.log("new component, dimensions loaded", newComponentDimension, componentDimensions);
      
      setTimeout(() => {
        showSettings(newComponentDimension['id'], false, null)

  
      }, 300);



    } 
   
  }, [newComponentDimension, componentDimensions]);

  useEffect(() => {
    if (sections) {
      let page = searchParams.get("page");
      if (page) {
        setSectionId(parseInt(page))
      }
    }
  }, [sections])
    
    useEffect(() => {
      if (sections && sectionId) {
        // console.log('sectionId', sectionId)

        let back = searchParams.get("back");
        let layers = searchParams.get("layers");

        if (back !== null) {
          setSearchParams({page: sectionId, back: back, layers: layers});
        } else {
          setSearchParams({page: sectionId, layers: layers});
        }

        

        let api_url = Config.baseURLcms  + "narrative-section/" + sectionId;

        function responseTask(response) {
          let newObj = response.data;
          // let tempSectionObj = sections.find(a => a.id === activeSectionObj?.id);
          // console.log("tempSectionObj", tempSectionObj)
          // if (tempSectionObj && (response.data['pip_loc'] !== tempSectionObj?.pip_loc)) {
          //   console.log('pip_loc changed', response.data['pip_loc'], tempSectionObj?.pip_loc)
          //   newObj['pip_loc'] = tempSectionObj?.pip_loc;
          // }
          setActiveSectionObj(newObj);
          console.log('section page get', newObj)
         
        }
        apiCall("GET", api_url, null, responseTask, null, setFormError, setShowLoader)

        // console.info("CMS: Page JSON", Config.baseURL + '/api/cms/section/' + sectionId + '/')
        // console.info("Layer CMS JSON", Config.baseURL + '/cms/component-dimension/' + sectionId + '/')
        // console.info("App: Page JSON", Config.baseURL + '/api/narrative/' + narrative.id + '/' + sectionId + '/')
        // console.info("App: Narrative JSON", Config.baseURL + '/api/narrative/' + narrative.id + '/')

      }
      return () => {
        setComponents([]);
        setComponentDimensions([]);
        console.log('set components to null')
      }
     
    }, [sectionId]);

    useEffect(() => {
     
      if (activeSectionObj) {
        console.log('activeSectionObj', activeSectionObj)

        if (activeSectionObj.components.length > 0) {
          setComponents(activeSectionObj.components)

          if (activeSectionObj.states.length > 0) {
            setActiveStateId(activeSectionObj.states[0].id)
          }

          var components = activeSectionObj.components;
          var dims = [];
          for(var i = 0; i < components.length; i++) {
            var obj = components[i];
              var dim = obj.dimensions.filter((dimension) => dimension.display === activeDisplay.id);
              if (dim.length !== 0) {
                // console.log('obj', obj, dim.length);
                dims.push(dim[0]);
              }
              
              if (i === (components.length - 1)) {
                setComponentDimensions(dims);
                console.log('dims set', dims, i, activeSectionObj.id)
                
              }
          }
  
        } else {
          setComponents([]);
          setComponentDimensions([]);
        }
      }
      return () => {
        setComponents([]);
        setComponentDimensions([]);
      }
    }, [activeSectionObj, updateFetch]);


    useEffect(() => {
      if (triggerSaveForm === true) {
        handleLayerSave();
        setTriggerSaveForm(false);
      }
      
    }, [triggerSaveForm, unSavedChanges, componentDimensions])

    useEffect(() => {
      if (activeSettingId) {
        // Only run when activeSettingId actually changed, not on componentDimensions-only updates
        const settingIdChanged = activeSettingId !== prevActiveSettingIdRef.current;
        prevActiveSettingIdRef.current = activeSettingId;
        if (!settingIdChanged) return;

        if (activeSettingId && componentDimensions && componentDimensions.length > 0) {

          updateVersionHistorySub(activeSectionObj, "page")

          if (componentDimensions.find(a => a.id === activeSettingId) && componentDimensions.find(a => a.id === activeSettingId).file_format === 'grp') {

            let parentId = componentDimensions.find(a => a.id === activeSettingId).component_id;
            let objs = componentDimensions.filter(a => a.parent === parentId)
            let ids = [];
            let multiObjs = [];
            objs.forEach(a => {
              ids.push(a.id);
              multiObjs.push(a)
            });

            setMultiSelectIds(ids);
            setMultiSelectObjs(multiObjs);

            console.log('setMultiSelectIds', ids);

          } else {
            console.log('activeSettingsId', activeSettingId, componentDimensions)
            setTimeout(() => {
              showSettings(activeSettingId, false, null)
            }, 500);
          }


        }
      } else {
        prevActiveSettingIdRef.current = null;
      }
    }, [activeSettingId, componentDimensions])

  useEffect(() => {
    if (dropDown) {
      animDropDown(true, activeSettingId, dropDown);
    } else {
      animDropDown(false, activeSettingId, dropDown)
    }
  }, [dropDown])

  useEffect(() => {
    if (activeSettingId) {
      stageLayerIds(activeSettingId)
      
      setShowPages(false)
    } else {
      // setShowPages(true)
    }
  }, [activeSettingId])

  useEffect(() => {
    // console.log('%c showPages', "font-weight:bold", showPages)
  }, [showPages])

  useEffect(() => {
    if (multiSelectIds) {
      
      multiSelectIds.forEach((id => {
        stageLayerIds(id)
      }));
     
    } else {
    
    }
  }, [multiSelectIds])


  
  function handleLayerAdded( format, 
    subformat, 
    y_pos, 
    x_pos,
    layerFormat,
    files) {

    setIsDrawing(false)
    setZoomNumber(1);
   

    handleLayerAddedMain(
      format, 
      subformat, 
      y_pos, 
      x_pos, 
      Config, 
      files,
      activeSectionObj, 
      unSavedChanges, 
      sectionId, 
      layerFormat, 
      aspectRatio, 
      newMedia, 
      setNewMedia, 
      setAcceptValues,
      setFormError,
      setShowLoader,
      setNewComponentID,
      setNewComponentDimension,
      props.user.org.validations,
      narrative.default_display,
      activeDisplay,
      fetchJSON,
      setActiveSectionObj
    )

  }

  function showSettings(objID, isSave, event, reloadLayers){

            if (layerClickCooldownRef.current) {
          return;
        }
        // Engage 750ms cooldown
        layerClickCooldownRef.current = true;
        if (isSave) setSaveCooldown(true);
        setTimeout(() => {
          layerClickCooldownRef.current = false;
          setSaveCooldown(false);
        }, 750);


    // setUnSavedChanges(true);
   
    console.log('showSettings', objID, isSave, event)
    // setActiveSettingId(null);
    // setComponentDimensions(null);
    // setTimeout(() => {

    //   showSettingsMain(objID, isSave, event, multiSelectIds, setMultiSelectIds, setActiveSettingId, componentDimensions, setComponentDimensions, setUnSavedChanges, setTriggerSaveForm, tempText, setNewComponentDimension);

    // }, 200);

    showSettingsMain(objID, isSave, event, multiSelectIds, setMultiSelectIds, setActiveSettingId, componentDimensions, setComponentDimensions, setUnSavedChanges, setTriggerSaveForm, tempText, setNewComponentDimension, tempTextObj);
    
  }

  function fetchJSON(hasNewObjId, displayChange, showSettings, callBack){
    console.log('fetchJSON', hasNewObjId, displayChange, showSettings)
    setShowLoader(true);
    let page = searchParams.get("page");
    let pageVal = null;
    // console.log('pageVal', pageVal, page, isNaN(page))
    if (isNaN(page)) {
    
    } else {
      pageVal = parseInt(page)
     
    }
    let onActiveDisplay = null

    if (!displayChange) {
      if ((props.activeDisplay && activeDisplayRef.current !== props.activeDisplay.id) || activeDisplayRef.current === -1) {
        // console.log('setActiveDisplay sent')
        onActiveDisplay = setActiveDisplay
      }
      
    }
     setZoomNumber(1);
    // setSectionId(null)
    fetchJSONMain(hasNewObjId, id, setNarrative, setNarrativeHeadings, setSections, sectionId, setSectionId, setShowLoader, setShowFullCanvas, setFormError, pageVal, onActiveDisplay, showSettings, setActiveNarrativeHeading, setActiveSettingId, callBack)

    // Zoom to fit after data refresh — for same-page refreshes where narrativeTools won't trigger
    if (!hasNewObjId || hasNewObjId === false) {
      setTimeout(() => {
        try {
          let canvasForm = document.getElementById('canvasForm');
          let canvasFormWrap = document.getElementById('canvasFormWrap');
          let x_perc = canvasFormWrap.getBoundingClientRect().width / (canvasForm.getBoundingClientRect().width + 50);
          if (x_perc < 0.97) {
            setZoomNumber(x_perc);
          }
        } catch (error) {
          console.log('zoom fit error', error);
        }
      }, 700);
    }
  }


    function handleSectionScrollOffset(e) {

      const timeout = setTimeout(() => {
        
        var scroll_offset = e.target.value;
        var newSections = [...sections];
        var objIndex = newSections.findIndex(x => x.id ===sectionId);
        var newObj = newSections[objIndex];
        var changesCopy = [ ...sectionChanges ];
        var sectionObj = {}
        sectionObj['id'] = sectionId;
        sectionObj['scroll_offset'] = scroll_offset
        sectionObj['ordering'] = newObj['ordering'];
        sectionObj['title'] = newObj['title'];
        sectionObj['active'] = newObj['active'];
        changesCopy.push(sectionObj);

        setSectionChanges(changesCopy);
        setSections(newSections);
        setUnSavedChanges(true);
        setSectionId(sectionId);

      }, 600);
      return () => {
        clearTimeout(timeout);
      };
      
    }

    function handleSectionOnlySave(){
      setZoomNumber(1);
      if (unSavedChanges) {
        handleLayerSave()
      } else {
        for(var i = 0; i < sectionChanges.length; i++) {
          if (sectionChanges[i].id === sectionId) {
            handleSectionSave(i);
          }
        }
      }
      // Zoom to fit after save — delay allows GSAP scale animation to complete at zoomNumber=1
      setTimeout(() => {
        try {
          let canvasForm = document.getElementById('canvasForm');
          let canvasFormWrap = document.getElementById('canvasFormWrap');
          let x_perc = canvasFormWrap.getBoundingClientRect().width / (canvasForm.getBoundingClientRect().width + 50);
          if (x_perc < 0.97) {
            setZoomNumber(x_perc);
          }
        } catch (error) {
          console.log('zoom fit error', error);
        }
      }, 700);
    }

    function handleNarrativeSave(field, value) {
      setShowLoader(true)
      const api_url = Config.baseURLcms + 'narrative-settings/' + narrative.id + "/";
      var dataJSON = {};
      if (field !== 'title') {
        dataJSON['title'] = narrative.title
      }
      // dataJSON['active'] = narrative.active;
      dataJSON[field] = value;
      
      console.log('handleNarrativeSave', dataJSON, api_url);
      function responseTask() {
        fetchJSON(false);
        setNarrativeChanges([]);
        if (field === "active") {
          navigate('/')
        }
      }
      apiCall("POST", api_url, dataJSON, responseTask, null, setFormError, setShowLoader)

    }

    function handleNarrativeHeadingEdit(field, value, objId) {
      console.log('handleNarrativeHeadingEdit recd', field, value, objId)
      if (activeNarrativeHeading || objId) {
        let objIndex;
        // let title = value;
        let newObjs = [...narrativeHeadings];
        if (objId) {
          objIndex = newObjs.findIndex(x => x.id === objId );
        } else {
          objIndex = newObjs.findIndex(x => x.id === activeNarrativeHeading.id );
        }
        
        let newObj = newObjs[objIndex];


        console.log('newObj', newObj)
        if (newObj) {
          newObj[field] = value;
          setNarrativeHeadings(newObjs);
        }
  
        const api_url = Config.baseURLcms + 'narrativeheading-edit/';
        let formData = {}
        if (objId) {
          formData['id'] = objId
        } else {
          formData['id'] = activeNarrativeHeading.id
          // console.log(activeNarrativeHeading.id, value)
        }
        
        formData[field] = value
        function responseTask(response) {
          fetchJSON(false)
          setEditPageForm(null);
          formInput.current = null;
          console.log('response', response)
        }

        console.log('handleNarrativeHeadingEdit formData', formData, api_url)

        apiCall("POST", api_url, formData, responseTask, null, setFormError, setShowLoader)

      }
      
    }

    function handleCloseSettings() {
      if (activeSettingId) {
        setActiveSettingId(null);
        // setShowManifest(false);
      } 
      
    }

    function handleComponentDimensionUpdate(dataJSON, objID, isLast) {

      console.log('handleComponentDimensionUpdate', dataJSON, objID, isLast)

      const api_url = Config.baseURLcms + 'component-dimension/' + objID + '/';
      function responseTask() {
        if (isLast === true) {
          // fetchSection(sectionId)
          let obj = componentDimensions.find((dimension) => dimension.id === activeSettingId);
          if (obj && obj.animations && obj.animations.length > 0) {

            if (obj.file_format === 'grp') {
              // This is a workaround for the grp file format, which needs to be reloaded
              // to show the new dimensions.
              setFormError(null)
              // console.log('handleComponentDimensionUpdate, grp', obj)
              window.location.reload();
            }

          } else {
            // fetchJSON();
            // setShowLoader(false);
            let renderCurr = rerender;
            setRerender(renderCurr+=1);

            console.log('handleComponentDimensionUpdate, no anim', obj)
          }

          setUnSavedLayerIds([]);
          setFormError(null)
        }
        // setShowLoader(false);
      }
      apiCall('POST', api_url, dataJSON, responseTask, null, setFormError, setShowLoader)
      
    }

    function handleAddAnimation(dataJSON) {
      
      const api_url = Config.baseURLcms + 'componentdimension-animation-add/';
      function responseTask() {
        // fetchSection(sectionId)
        // fetchJSON();
      }
      apiCall('POST', api_url, dataJSON, responseTask, null, setFormError, setShowLoader)
      
    }
    function handleReloadSection(response) {
      fetchJSON(false, false, null, () => {
        let api_url = Config.baseURLcms + "narrative-section/" + sectionId;
        apiCall("GET", api_url, null, (res) => {
          setActiveSectionObj(res.data);
        }, null, setFormError, setShowLoader);
      });
    }
    
    function handleEditAnimation(dataJSON) {
      const api_url = Config.baseURLcms + 'componentdimension-animation-edit/';
      function responseTask() {
        // fetchSection(sectionId)
        // fetchJSON();
      }
      apiCall('POST', api_url, dataJSON, responseTask, null, setFormError, setShowLoader)
    }

    function handleSectionSave(i, changeDataObj) {
      console.log('handleSectionSave', i)
      setShowLoader(true)
      const api_url = Config.baseURLcms + 'section-edit/';
      let changes = [...sectionChanges];
      let changeData
      if (changeDataObj) {
        changeData = changeDataObj
      } else {
        changeData = changes[i];
      }
      var dataJSON;
      dataJSON = {
        'id': changeData.id,
        'scroll_offset': changeData.scroll_offset,
        'title': changeData.title,
        'active': changeData.active,
        'notes': changeData.notes,
        'force_version': forceVersion,
        'pip_loc': changeData.pip_loc
      }
      console.log('handleSectionSave', dataJSON, api_url, forceVersion);
      function responseTask(response) {
        handleReloadSection(response);
      }
      apiCall('POST', api_url, dataJSON, responseTask, null, setFormError, setShowLoader)
      

    }
    
    function onNewPage(){
      let pageCount = narrative.cms_sections.length;
      if (pageCount < props.user.org.validations.maxPages) {
       setShowPageForm(true);

      } else {
        let newError = {
          "heading": "Note",
          "text": "You current have <strong>" + pageCount + "</strong> pages, the maximum number of pages permitted in a narrative."
        };
        setFormError(newError);
      }
    
    }

    function handleAddSection() {
      

      let pageCount = narrative.cms_sections.length;
      if (pageCount < props.user.org.validations.maxPages) {
        
        setShowLoader(true);
        setShowPageForm(false)
        setShowNarrativeHeadingForm(false);

        // setZoomNumber(1)

        const api_url = Config.baseURLcms + 'section-add/';
        var dataJSON = {
          'narrative_id': narrative.id,
          'title': formInput.current
        }
        function responseTask(response){
          localStorage.removeItem("versionHistory");
          versionNumber.current = -1
          setVersionCount(0);

          setTimeout(() => {
            console.log('handleAddSection callback response', response.data)
            fetchJSON(response.data, null, null, null, null)
          }, 200);

          
          setUnSavedChanges(false);
        }
        apiCall('POST', api_url, dataJSON, responseTask, null, setFormError, setShowLoader)

      } else {
        let newError = {
          "heading": "Note",
          "text": "You current have <strong>" + pageCount + "</strong> pages, the maximum number of pages permitted in a narrative."
        };
        setFormError(newError);
      }
    
    }

    function handleDeleteSection(choice) {

      localStorage.removeItem("versionHistory");

      console.log('handleSectionDelete', sections, sections.length);

      if (sections.length > 1) {

        if (choice === 'cancel') {
          setShowDeleteSection(false);
        } else {

          setShowLoader(true);
          const api_url = Config.baseURLcms + 'section-delete/';
          var dataJSON = {
            'section_id': sectionId,
          }
          function response() {
            setShowDeleteSection(false);
            // Find the index of the deleted section and navigate to a valid page
            const deletedIndex = sections.findIndex(s => String(s.id) === String(sectionId));
            const nextPage = deletedIndex === 0 ? sections[1] : sections[deletedIndex - 1];
            const nextPageId = nextPage.id;

            // Update URL param before reload so it doesn't re-fetch the deleted page
            const params = new URLSearchParams(window.location.search);
            params.set('page', nextPageId);
            window.history.replaceState({}, '', '?' + params.toString());

            // WORKAROUND NEED TO FIX THIS
            window.location.reload();
          }
          apiCall('POST', api_url, dataJSON, response, null, setFormError, setShowLoader)
    

        }
      } else {
        setShowDeleteSection(false);
      }


    }

    function handleAspectLock(objID) {
      if (showFormatLockWarning !== false) {
        var newComponents = [...componentDimensions];
        var newIndex = newComponents.findIndex(item => item.id === objID);

        // console.log('isLocked', newIndex, objID);

        var newObj = newComponents[newIndex];
        var is_locked = newObj['is_locked'];
        if (is_locked === true) {
          newObj['is_locked'] = false;

        } else {
          newObj['is_locked'] = true;
        }

        setComponentDimensions(newComponents);
        setUnSavedChanges(true);
        setShowFormatLockWarning(false);

      } else {
        let isLocked = componentDimensions.find(a => a.id === objID).is_locked
        console.log('isLocked Warning', isLocked)
        setShowFormatLockWarning([objID, isLocked]);
      }
      
    }

  function handleBackBtn(step){
    if (step === 'step1') {
      setShowError(true);
    } 
    if (step === 'cancel') {
      setShowError(false);
      setShowDeleteSection(false)
    } 
   
    if (step === 'force') {
      if (!showPages) {
        // console.log('handleBackBtn: force')
       setShowPages(true);
        setActiveSettingId(null);
        
        setShowError(false);
      } else {
        navigate('/narratives/' + narrative.id)
        setShowError(false);
        
      }
    } 
  }

  function handleSectionActive(value) {
    console.log('handleSectionActive', value)
    var newSections = [...sections];
    var objIndex = newSections.findIndex(x => x.id === parseInt(sectionId));
    if (objIndex > -1) {
       var newObj = newSections[objIndex];
      var changesCopy = [ ...sectionChanges ];
      var sectionObj = {}
      sectionObj['id'] = sectionId;
      sectionObj['scroll_offset'] = newObj['scroll_offset']
      sectionObj['ordering'] = newObj['ordering'];
      sectionObj['title'] = newObj['title'];
      sectionObj['active'] = value;
      changesCopy.push(sectionObj);

      setSectionChanges(changesCopy);
      setUnSavedChanges(true);
      setActiveSectionObj({...activeSectionObj, active: value});
    }

  }



  function handlePageClick(menuItemObj, e){

    // Skip if clicking on the current page
    const clickedPageId = menuItemObj.page || menuItemObj.id;
    if (clickedPageId === sectionId) {
      return;
    }

    if (sections.length > 1) {
      setShowLoader(true)

    // setActiveSectionObj(null)
    setZoomNumber(1)
    console.log('handlePageClick', menuItemObj, e)
    
    let otherSelects;
    if (unSavedChanges) {
      let newError = {
        "heading": "Warning",
        "text": "You have unsaved changes.",
        "btn2Text": "Save & Continue",
        "onBtn2Click": handleLayerSave,
        "onBtn2": menuItemObj,
        "btn3Text": "Don't Save",
        "onBtn3Click": handleDontSave,
        "onBtn3": menuItemObj
      };
      setFormError(newError);
    } else {
      if (e && e.shiftKey) {

        // Multiselect to group pages
        if (multiSelectPageIds.length > 0) {
          otherSelects = [ ...multiSelectPageIds ]
          let otherSelectsIndex = otherSelects.findIndex(a => a === menuItemObj.id);
          if (otherSelectsIndex > -1) {
            otherSelects.splice(otherSelectsIndex, 1)
          } else {
            otherSelects.push(menuItemObj.id)
          }
        } else {
          otherSelects = [menuItemObj.id]
        }
        if (activeSectionObj.nav) {
          otherSelects.push(activeSectionObj.nav.id)
        }
        
        console.log('setMultiSelectPageIds', otherSelects, activeSectionObj.nav.id)
        setMultiSelectPageIds(otherSelects);

      }
      
      setFormError(null);
      handleCloseSettings();
    
      if (menuItemObj.page) {
        setSectionId(menuItemObj.page);
        setActiveNarrativeHeading(menuItemObj);
      } else if (menuItemObj.page === null){
        setActiveNarrativeHeading(menuItemObj);
      } else {
        setSectionId(menuItemObj.id);
      }

      if (menuItemObj.page === sectionId) {
        setShowLoader(false)
      }

      localStorage.removeItem("versionHistory");
      versionNumber.current = -1
      setVersionCount(0);
      
    }
    
  }
    // setActiveMenuItem(menuItemObj)
  }


function handleOnKeyUp(e, field, objId) {
 
    if (field === "dimension_text") {
      tempTextObj.current = e.target.value;
    }
    if (field === "narrativeTitle") {
      
      if (e.key === "Enter") {
        handleNarrativeSave("title", e.target.value)
      } else {
        // let nCopy = [...narrativeChanges];
        let nCopy = []
        let nCopyObj = {}
        nCopyObj['title'] = e.target.value
        nCopy.push(nCopyObj)
        setNarrativeChanges(nCopy);
        // console.log('nCopy', nCopy, narrativeChanges.length)
      }
    }
    if (field === "narrativeHeading") {
      pendingHeadingChange.current = { value: e.target.value, objId: objId };
      setUnSavedChanges(true);
    }

}

  function handleNarrativeAdd(value, value2) {
    // console.log('handleNarrativeAdd', value, value2)
    setShowLoader(true)
    const api_url = Config.baseURLcms + 'narrativeheading-add/';
    var dataJSON = {};
    // if (field !== 'heading') {
    //   dataJSON['heading'] = narrative.title
    // }
    dataJSON['narrative_id'] = id;
    dataJSON['heading'] = value;
    dataJSON['page_id'] = value2;
    

    // console.log('dataJSON', dataJSON)
    function responseTask() {
    
      fetchJSON(false);
      setShowNarrativeHeadingForm(false);
      tempNarrativeHeading.current = null;
    }
    apiCall("POST", api_url, dataJSON, responseTask, null, setFormError, setShowLoader)

  }

  function handleCreateNarrativeHeading(inputId, inputId2) {
    let value = document.getElementById(inputId).value;
    let value2 = document.getElementById(inputId2).value;
    
    if (value && value2) {
      handleNarrativeAdd(value, value2)
    } else {
      if (value && !value2) {
        gsap.fromTo('#narrativeHeadingNew_page .anim', {color: "red", duration: 1}, {color: "white", duration: 1})
      }
      if (!value && value2) {
        gsap.fromTo('#narrativeHeadingNew', {background: "red"}, {background: "#555555"})
      }
      if (!value && !value2) {
        gsap.fromTo('#narrativeHeadingNew_page .anim', {color: "rgba(255,0,0,0.2)", duration: 1}, {color: "white", duration: 1})
        gsap.fromTo('#narrativeHeadingNew', {background: "rgba(255,0,0,0.2)"}, {background: "#555555"})
      }
    }
  }

  function updateNarrativeHeadingForm(fieldId, value, label) {
    // console.log(fieldId, value, label)
    if (fieldId === 'narrativeHeadingPage' && value) {
      tempNarrativeHeading.current = label
      document.getElementById('narrativeHeadingPage').value = value
      setDropDown(null);
      handleNarrativeHeadingEdit('page_id', value)
    }
  }

  function handleDropDown(e, field) {
    if (field === dropDown) {
      setDropDown(null); 
    } else {
      setDropDown(field)
    }
  }

  function reNameHeading() {
    handleNarrativeHeadingEdit('heading', formInput.current, editPageForm);
  }

  function handleAddNewTab() {
    
  }

  function updateLayers(sectionId){
    console.log("updateLayers", sectionId)
    setSectionId(sectionId)
  }

  function handlePipLoc(value){
  
    var newSections = [...sections];
    var objIndex = newSections.findIndex(x => x.id === parseInt(sectionId));
    console.log('handlePipLoc', value, sectionId, objIndex)
    if (objIndex > -1) {
      var newObj = newSections[objIndex];
      var changesCopy = [ ...sectionChanges ];
      var sectionObj = {}
      sectionObj['id'] = sectionId;
      sectionObj['scroll_offset'] = newObj['scroll_offset']
      sectionObj['ordering'] = newObj['ordering'];
      sectionObj['title'] = newObj['title'];
      sectionObj['active'] = newObj['active'];
      sectionObj['pip_loc'] = value;
      

      // changesCopy.push(sectionObj);
      // setSectionChanges(changesCopy);
      // setSections(newSections);

      handleSectionSave(-1, sectionObj);
      // setUnSavedChanges(true);
      // setSectionId(sectionId);

      console.log('handlePipLoc end', value, newSections, sectionObj)
    }
    
  }

  function emptyCall(){
    console.log("skip")
  }

  function onAddAsset(objId, methodOrId) {
    console.log('onAddAsset', objId, methodOrId)

    // let layerCount = activeSectionObj.components.filter(a => a.component !== 'GRP').length
    // Need to add layer validation here

    var formData = new FormData();
    let formHeaders = {
        'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
      }
    setZoomNumber(1);
   

    setShowAssetLibrary(false);
    setShowLoader(true);

    let api_url;
    
    if (methodOrId === 'add') {
      api_url = Config.baseURLcms + 'section-component-add-from-library/';
      formData.append('section_id', sectionId);
      formData.append('library_asset_id', objId);
      formData.append('display_id', narrative.default_display);
      formData.append('background', false);
    } else {
      api_url = Config.baseURLcms + 'section-component-replace-from-library/';
      formData.append('library_asset_id', objId);
      formData.append('id', methodOrId);
    }

    function responseTask(response){
      setAcceptValues && setAcceptValues(null);

      // Directly fetch section data to get the new/replaced asset
      let sectionUrl = Config.baseURLcms + "narrative-section/" + activeSectionObj.id;
      apiCall("GET", sectionUrl, null, function(sectionResponse) {
        setActiveSectionObj(sectionResponse.data);
        if (response.data && response.data['dimension_id']) {
          setNewComponentDimension({id: response.data['dimension_id'], 'file_format': response.data['format']});
        }
        setShowLoader(false);
      }, null, setFormError, setShowLoader);
    }
    apiCall("POST", api_url, formData, responseTask, formHeaders)

  }

  function onZoomChoice(val) {
    console.log('onZoomChoice', val)
      setDropDown(null);
      switch (val) {
        case 'fit':
          // let perc = 55
          // setZoomState(perc)
          try {
            let canvasForm = document.getElementById('canvasForm');
            let canvasFormWrap = document.getElementById('canvasFormWrap');
            let x_perc = canvasFormWrap.getBoundingClientRect().width/(canvasForm.getBoundingClientRect().width + 50);
            // let y_perc = canvasFormWrap.getBoundingClientRect().height/canvasForm.getBoundingClientRect().height + 50;
            if (x_perc<0.97){
              setZoomNumber(zoomNumber*x_perc);
              console.log('settings zoomNumber', zoomNumber*x_perc)
            } 
          } catch (error) {
            console.log('resize error', error)
          } 
          break;
      
        default:
          break;
      }
    }

function onTemplate(objId) {
      setShowTemplateModal(false);
      setZoomNumber(1);
      let pageCount = narrative.cms_sections.length;
      if (pageCount < props.user.org.validations.maxPages) {
        
         setShowLoader(true);
        const api_url = Config.baseURLcms + 'template-add-page/';
        var dataJSON = {
          'narrative_id':narrative.id,
          'section_id': objId
        }
        function responseTask(response){
          //temp
          window.location.reload();
          
          // setTimeout(() => {
          //   fetchJSON(response.data,null,null,null,null)
          // }, 200);
          
          // setUnSavedChanges(false);
        }
        apiCall('POST', api_url, dataJSON, responseTask, null,  setFormError,  setShowLoader)

      } else {
        let newError = {
          "heading": "Note",
          "text": "You current have <strong>" + pageCount + "</strong> pages, the maximum number of pages permitted in a narrative."
        };
         setFormError(newError);
      }
    
    }

  function moveToPagePart1(dest) {
    destPageIdRef.current = dest;
    setDropDown(null)
  }

  function moveToPagePart2(objId) {
    console.log('movePage', objId, destPageIdRef.current.id);
    let destId = destPageIdRef.current.id;
    const api_url = Config.baseURLcms + 'layer-move/';
        var dataJSON = {
          'obj_id':objId,
          'dest_id': destId
        }

        // console.log('dataJSON', dataJSON)
      function responseTask(response){

        setTimeout(() => {
          fetchJSON(destId,null,null,null,null)
        }, 200);
        
        setShowMoveModal(false)
        
      }
      apiCall('POST', api_url, dataJSON, responseTask, null,  setFormError,  setShowLoader)
  }

    return (
        <section className={classNames("component", "on", (narrative && narrative.template_id && (narrative.template_id === narrative.id)) && "templatesPage")} id="narrativeDetail">

        

        {(showLoader)?(<div id="loading"><img src={Loader} alt="" /></div>):null}

        {(formError)&&<Modal heading={formError.heading} text={formError.text} onBtn1Click={setFormError} onBtn1={null} btn1Text={"Cancel"} onBtn2Click={formError.onBtn2Click} onBtn2={formError.onBtn2} btn2Text={formError.btn2Text} onBtn3Click={formError.onBtn3Click} onBtn3={formError.onBtn3} btn3Text={formError.btn3Text} />}

        {showAssetLibrary && <span className="modalShade"><span className="modalContainer libraryModal"><Library setSmLogo={emptyCall} user={props.user} setTools={props.setTools} status={'deleted'} setShowInfo={props.setShowInfo} showInfo={props.showInfo} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} setShowAssetLibrary={setShowAssetLibrary} isModal={true} addAsset={onAddAsset} showAssetLibrary={showAssetLibrary} /></span></span>}


        {(newTab)&&<Modal heading={"New Tab"} formInput={<div className="settingsRow"><input type="text" autoComplete="off" id="newTabName" required onChange={(e) => {formInput.current = e.target.value}} placeholder="Add a Name" /></div>} onBtn1Click={setNewTab} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={handleAddNewTab} onBtn2={formInput.current} btn2Text={"Create"} />}

        {(showError)&&(<div className="modalContainer"><div className="modal"><span className="textContainer"><h3>Unsaved Changes</h3><p>Are you sure you want to go back?</p></span> <div className="fullRow errorRow"><span onClick={() => handleBackBtn('cancel')}>Cancel</span> <span onClick={() => handleBackBtn('force')}>Continue</span></div></div></div>)}

        {(showDeleteSection)&&(<div className="modalContainer"><div className="modal"><span className="textContainer"><h3>Caution</h3><p>Are you sure you want to delete this page?<br />This action cannot be undone.</p></span> <div className="fullRow errorRow"><span onClick={() => handleBackBtn('cancel')}>Cancel</span> <span onClick={() => handleDeleteSection('continue')}>Delete</span></div></div></div>)}

        {(showFormatLockWarning !== false)&&(
        
          <Modal heading={"Caution"} text={showFormatLockWarning[1]?"<p>This layer's settings are handled automatically across all displays, based on the choices you make here in your default settings.<br/><br/>Click continue to detach formats and update the layers on each display size manually</p>":"<p>This layer's settings will be handled manually across all displays.<br/><br/>Click continue to attach formats and update the layers on each display size automatically</p>"} onBtn1Click={setShowFormatLockWarning} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={handleAspectLock} onBtn2={showFormatLockWarning[0]} btn2Text={"Continue"} />
        )}

        {showPageForm && <Modal heading={"New Page"} formInput={<div className="settingsRow"><input type="text" autoComplete="off" id="narrativeTitle" required onChange={(e) => {formInput.current = e.target.value}} placeholder="Add a Title" /></div>} onBtn1Click={setShowPageForm} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={handleAddSection} onBtn2={formInput.current} btn2Text={"Create"} />}

        {editPageForm && <Modal heading={"Page Title"} formInput={<div className="settingsRow"><input type="text" autoComplete="off" id="pageTitle" required onChange={(e) => {formInput.current = e.target.value}} placeholder="Add a Title" /></div>} onBtn1Click={setEditPageForm} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={reNameHeading} onBtn2={formInput.current} btn2Text={"Save"} />}

        {showTemplateModal && (<div className="modalContainer"><div className="modal"><span className="textContainer"><h3>Add a New Templated Page</h3><p>Click continue to create a new <strong>{showTemplateModal.title}</strong> page</p></span> <div className="fullRow errorRow"><span onClick={() => setShowTemplateModal(false)}>Cancel</span> <span onClick={() => onTemplate(showTemplateModal.id)}>Continue</span></div></div></div>)}

        {showMoveModal && (<div className="modalContainer"><div className="modal">
            
          <span className="textContainer" id="settingsRow_moveChoices"><h3>Move Layer</h3>

          <span className="settingsRow">

           <div className="ui pageDropDown" onClick={(e) => {handleDropDown(e, 'moveChoices'); setActiveSettingId(null)}}>{destPageIdRef.current ?<span className="ui btn1">{destPageIdRef.current.nav.heading}<ChevronDown className="down" style={{paddingLeft: "10px"}} /></span> :<span className="btn1"><span className="anim">Select Page</span>
             <ChevronDown className="down" style={{paddingLeft: "10px"}} />
           </span>}
          
            </div>
          
            
            <span className="inputField dropDownField" style={{margin: '0 auto'}}  id={"inputField_moveChoices_new"}>
              <span className="dropDown">
                <span className="dropDownChoices">
                  {sections
                    .filter(a => a.title !== null)
                    .map((obj, i) => (
                    <span key={'moveChoices_'+i} className={"dropDownChoice ui"} onClick={() => moveToPagePart1(obj)}>{obj.nav.heading}
             
                    </span>
                  ))}
                </span>
              </span>
            </span>

          </span> 
        </span>
          <div className="fullRow errorRow">
        <span onClick={() => setShowMoveModal(false)}>Cancel</span> <span onClick={() => moveToPagePart2(showMoveModal)}>Move</span>
        </div></div></div>)}

        {(showNarrativeHeadingForm)&&(<div className="modalContainer"><div className="modal"><span><h3>New Navigation Item</h3>
        <div className="settingsRow">
         <input type="text" autoComplete="off" id="narrativeHeadingNew" placeholder="Add a Heading" />
        </div>
        <div className="settingsRow" id="settingsRow_navSection">
          <input type="hidden" autoComplete="off" id="narrativeHeadingPage" />
          <span id={"settingsRow_navSection"}></span>
          <div  className="ui pageDropDown modalBtn" onClick={(e) => handleDropDown(e, 'navSection')}>{tempNarrativeHeading.current ?<span className="dropDownSelection ui">{tempNarrativeHeading.current}</span>:<span className="btn1"><span className="anim">Add Page</span></span>}
          
          </div>
            
            <span className="inputField dropDownField" id={"inputField_navSection_new"}>
              <span className="dropDown">
                <span className="dropDownChoices">
                  {sections
                    .filter(a => a.title !== null)
                    .map((obj, i) => (
                    <span key={'sectionHeading_'+i} className={"dropDownChoice ui"} onClick={() => updateNarrativeHeadingForm('narrativeHeadingPage', obj.id, obj.title)}>{obj.title}</span>
                  ))}
                </span>
              </span>
            </span>
        
        </div>
        </span> <div className="fullRow errorRow"><span onClick={() => setShowNarrativeHeadingForm(false)}>Cancel</span> <span onClick={() => handleCreateNarrativeHeading("narrativeHeadingNew", "narrativeHeadingPage")}>Create</span></div></div></div>)}


        {narrative && <NarrativeTools 
          activeSectionObj={activeSectionObj} 
          section={section}
          activeDisplay={activeDisplay}
          setActiveDisplay={setActiveDisplay}
          defaultDisplay={narrative.default_display}
          aspectRatio={aspectRatio}
          setAspectRatio={setAspectRatio}
          sectionId={sectionId}
          newMedia={newMedia}
          showFullCanvas={showFullCanvas}
          user={props.user}
          narrative={narrative}
          zoomNumber={zoomNumber}
          zoomRatio={zoomRatio}
          unSavedChanges={unSavedChanges}
          setShowFullCanvas={setShowFullCanvas}
          setNewMedia={setNewMedia}
          setShowLoader={setShowLoader}
          setNewComponentID={setNewComponentID}
          setNewComponentDimension={setNewComponentDimension}
          setActiveSettingId={setActiveSettingId}
          setFormError={setFormError}
          setZoomNumber={setZoomNumber}
          setZoomRatio={setZoomRatio}
          onMouseEnter={props.onMouseEnter}
          onMouseLeave={props.onMouseLeave}
          setNewTab={setNewTab}
          fetchJSON={fetchJSON}
          publishOn={publishOn}
          setPublishOn={setPublishOn}
          showPages={showPages}
          setShowPages={setShowPages}  
          onNewPage={onNewPage}
          zoomDelta={zoomDelta}
          setShowAssetLibrary={setShowAssetLibrary}
          setIsDrawing={setIsDrawing}
          isDrawing={isDrawing}
          handleLayerAdded={handleLayerAdded}
          setShowTemplates={setShowTemplates}
        />}

        <div className={"formPage " + (showLoader)?(null):(' ready')}>

          {(narrative) &&
          <LeftNav 
            showPages={showPages}
            componentDimensions={componentDimensions}
            narrative={narrative}
            multiSelectPageIds={multiSelectPageIds}
            unSavedChanges={unSavedChanges}
            activeSettingId={activeSettingId}
            activeSectionObj={activeSectionObj}
            sectionId={sectionId}
            narrativeHeadings={narrativeHeadings}
            activeNarrativeHeading={activeNarrativeHeading}
            fetchJSON={fetchJSON}
            updateLayers={updateLayers}
            user={props.user}
            handlePageClick={handlePageClick}
            showSettings={showSettings}
            reload={reload}
            activeStateId={activeStateId}
            activeDisplay={activeDisplay}
            setComponentDimensions={setComponentDimensions}
            setUnSavedChanges={setUnSavedChanges}
            setShowError={setShowError}
            setShowDeleteSection={setShowDeleteSection}
            setShowPages={setShowPages}
            setActiveSettingId={setActiveSettingId}
            setShowPageForm={setShowPageForm}
            onNewPage={onNewPage}
            setNarrativeHeadings={setNarrativeHeadings}
            setSectionId={setSectionId}
            setShowLoader={setShowLoader}
            setActiveSectionObj={setActiveSectionObj}
            setMultiSelectPageIds={setMultiSelectPageIds}
            setEditPageForm={setEditPageForm}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            setZoomNumber={setZoomNumber}
            setFormError={setFormError}
            onZoomChoice={onZoomChoice}
            setShowMoveModal={setShowMoveModal}
            missingMediaIds={missingMediaIds}
          />
          }
              
          {narrative && activeDisplay && stateImages && componentDimensions && <Frame 
          // key={JSON.stringify(narrative.modified).length}
          // test={JSON.stringify(narrative.modified)}
          baseZoomRatio={baseZoomRatio}
          aspectRatio={aspectRatio}
          showFullCanvas={showFullCanvas}
          componentDimensions={componentDimensions}
          stateImages={stateImages}
          showSettings={showSettings}
          tempTextObj={tempTextObj}
          zoomRatio={zoomRatio}
          zoomNumber={zoomNumber}
          multiSelectIds={multiSelectIds}
          lockAr={lockAr}
          narrative={narrative}
          section={section}
          selection={selection}
          loading={showLoader}
          windowSelection={windowSelection}
          activeSectionObj={activeSectionObj}
          activeSettingId={activeSettingId}
          setMultiSelectIds={setMultiSelectIds}
          activeStateId={activeStateId}
          setComponentDimensions={setComponentDimensions}
          setUnSavedChanges={setUnSavedChanges}
          setTriggerSaveForm={setTriggerSaveForm}
          setActiveSettingId={setActiveSettingId}
          setDropDown={setDropDown}
          setSelection={setSelection}
          setWindowSelection={setWindowSelection}
          activeDisplay={activeDisplay}
          defaultDisplay={narrative.default_display}
          setTempText={setTempText}
          tempText={tempText}
          setShowPages={setShowPages}
          setZoomDelta={setZoomDelta}
          setFormError={setFormError}
          setStateImages={setStateImages}
          setShowLoader={setShowLoader}
          isDrawing={isDrawing}
          setIsDrawing={setIsDrawing}
          setActiveSectionObj={setActiveSectionObj}
          user={props.user}
          handleLayerAdded={handleLayerAdded}
          fetchJSON={fetchJSON}
          unSavedChanges={unSavedChanges}
          rerender={rerender}
          reloadFrame={reloadFrame}
          setReloadFrame={setReloadFrame}
          setZoomNumber={setZoomNumber}
          setNewComponentDimension={setNewComponentDimension}
          onZoomChoice={onZoomChoice}
        />}

          {activeSectionObj && activeSectionObj.states.length > 0 && <TabButtons
            aspectRatio={aspectRatio}
            section={section}
            activeSectionObj={activeSectionObj}
            activeStateId={activeStateId}
            setActiveStateId={setActiveStateId}
            
          />}

          {!activeSettingId && activeSectionObj && !showTemplates &&
          <PageSettings
            user={props.user}
            activeSettingId={activeSettingId}
            activeSectionObj={activeSectionObj}
            handleOnKeyUp={handleOnKeyUp}
            showSettings={showSettings}
            unSavedChanges={unSavedChanges}
            setShowLoader={setShowLoader}
            setSectionId={setSectionId}
            componentDimensions={componentDimensions}
            fetchJSON={fetchJSON}
            handleSectionScrollOffset={handleSectionScrollOffset}
            handleSectionOnlySave={handleSectionOnlySave}
            handleSectionActive={handleSectionActive}
            setShowDeleteSection={setShowDeleteSection}
            sections={sections}
            sectionChanges={sectionChanges}
            setSections={setSections}
            setUnSavedChanges={setUnSavedChanges}
            setSectionChanges={setSectionChanges}
            setForceVersion={setForceVersion}
            handleLayerSave={handleLayerSave}
            handlePipLoc={handlePipLoc}
            templateId={narrative.template_id}
            narrativeId={narrative.id}
          />
          }

          {showTemplates &&
          <TemplateSettings 
            user={props.user}
            narrative={narrative}
            activeSettingId={activeSettingId}
            activeSectionObj={activeSectionObj}
            handleOnKeyUp={handleOnKeyUp}
            showSettings={showSettings}
            unSavedChanges={unSavedChanges}
            setShowLoader={setShowLoader}
            setSectionId={setSectionId}
            componentDimensions={componentDimensions}
            fetchJSON={fetchJSON}
            handleSectionScrollOffset={handleSectionScrollOffset}
            handleSectionOnlySave={handleSectionOnlySave}
            handleSectionActive={handleSectionActive}
            setShowDeleteSection={setShowDeleteSection}
            sections={sections}
            sectionChanges={sectionChanges}
            setSections={setSections}
            setUnSavedChanges={setUnSavedChanges}
            setSectionChanges={setSectionChanges}
            setForceVersion={setForceVersion}
            showTemplates={showTemplates}
            setShowTemplates={setShowTemplates}
            setFormError={setFormError}
            setShowTemplateModal={setShowTemplateModal}
            // templateNarrative={narratives.filter(a => a.template=true)}
          />
          }

                

          {activeSectionObj && 
            <PageNotes  
              activeSectionObj={activeSectionObj}
              setSectionChanges={setSectionChanges}
              handleSectionSave={handleSectionSave}
              setFormError={setFormError}
            />}

          {!showTemplates && activeSettingId && sectionId && narrative &&
          <LayerSettings
            user={props.user}
            activeSettingId={activeSettingId}
            componentDimensions={componentDimensions}
            narrativeHeadings={narrativeHeadings}
            aspectRatio={aspectRatio}
            newMedia={newMedia}
            acceptValues={acceptValues}
            multiSelectIds={multiSelectIds}
            multiSelectObjs={multiSelectObjs}
            section={activeSectionObj}
            sectionId={sectionId}
            unSavedChanges={unSavedChanges}
            saveCooldown={saveCooldown}
            unSavedLayerIds={unSavedLayerIds}
            stageLayerIds={stageLayerIds}
            newAnimObj={newAnimObj}
            lockAr={lockAr}
            animationPresets={animationPresets}
            showSettings={showSettings}
            fetchJSON={fetchJSON}
            activeStateId={activeStateId}
            activeSectionObj={activeSectionObj}
            versionNumber={versionNumber.current}
            setShowLoader={setShowLoader}
            setNewMedia={setNewMedia}
            setUnSavedChanges={setUnSavedChanges}
            setComponentDimensions={setComponentDimensions}
            setActiveSettingId={setActiveSettingId}
            setActiveSectionObj={setActiveSectionObj}
            setAcceptValues={setAcceptValues}
            setNewComponentPopUpID={setNewComponentPopUpID}
            setNewAnimObj={setNewAnimObj}
            setFormError={setFormError}
            showFormatLockWarning={showFormatLockWarning}
            setShowFormatLockWarning={setShowFormatLockWarning}
            setLockAr={setLockAr}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            selection={selection}
            setSelection={setSelection}
            updateVersionHistorySub={updateVersionHistorySub}
            defaultDisplay={narrative.default_display}
            activeDisplay={activeDisplay}
            windowSelection={windowSelection}
            setTempText={setTempText}
            tempText={tempText}
            tempTextObj={tempTextObj}
            updateFetch={updateFetch}
            setUpdateFetch={setUpdateFetch}
            setZoomNumber={setZoomNumber}
            setShowAssetLibrary={setShowAssetLibrary}
            setReloadFrame={setReloadFrame}
            reloadFrame={reloadFrame}
            missingMediaIds={missingMediaIds}
            zoomRatio={zoomRatio}
          />}


        </div>
        
      </section>
    );
}
export default Canvas;


